import clsx from "clsx";
import { useContext, useState } from "react";
import translate from "../../locales";
import { ClassroomContext } from "../classroom.context";

const numberRegex = /^[0-9]*$/;

export function NumberInput({
  id = "",
  required = true,
  placeholder = "",
  min = 0,
  max = 999999,
  maxLength = 6,
}) {
  const {
    form: { touched },
    getField,
    setField,
    setTouched,
  } = useContext(ClassroomContext);
  const [value, setValue] = useState(getField(id));

  const onChangeText = (e) => {
    if (!numberRegex.test(e.target.value)) return;
    if (e.target.value.toString().length > maxLength) return;

    setValue(e.target.value);
    setField(id, e.target.value);
  };

  return (
    <div
      className={clsx(
        "input",
        required && touched[id] && !value && "input--invalid",
      )}
    >
      <input
        id={id}
        className={clsx("input__field")}
        type="number"
        min={min}
        max={max}
        placeholder={translate(placeholder)}
        onChange={onChangeText}
        onBlur={() => setTouched(id)}
        value={value}
      />
      <span className={clsx("input__helper")}>
        {translate("exercise.ui.text-input-footer", {
          count: value.length,
          limit: maxLength,
        })}
      </span>
    </div>
  );
}
